import gql from 'graphql-tag'

export const GET_DEPARTMENTS = gql`
  query {
    getDepartments {
      id
      departmentName
      head {
        id
        firstName
        lastName
      }
    }
  }
`

export const GET_TEAMS = gql`
  query {
    getTeams {
      id
      departmentId
      teamName
      teamLeaderId
      # currentLoadScore
      department {
        id
        departmentName
      }
      teamLeader {
        id
        firstName
        lastName
      }
    }
  }
`

export const GET_TEAM_MEMBERS = gql`
  query {
    getTeamMembers {
      id
      teamId
      userId
      specialization
      isAvailable
      ticketLoad
      maxTicketLoad
      user {
        id
        firstName
        lastName
        role
        userName
      }
      team {
        id
        teamName
        department {
          id
          departmentName
        }
      }
    }
  }
`

export const GET_ESCALATION_RULES = gql`
  query {
    getEscalationRules {
      id
      priorityId
      escalateTo
      triggerValue
      actionDescription
      priority {
        id
        priorityLevel
        slaTime
      }
    }
  }
`

// export const GET_KEYWORD_MAPPINGS = gql`
//   query {
//     getKeywordMappings {
//       id
//       keyword
//       departmentId
//       teamId
//       suggestsPriority {
//         id
//         priorityLevel
//         slaTime
//       }
//       isActive
//       department {
//         id
//         departmentName
//       }
//       team {
//         id
//         teamName
//       }
//     }
//   }
// `;

export const GET_KEYWORD_MAPPING = gql`
  query GetKeywordMappings {
    getKeywordMappings {
      departmentId
      department {
        id
        departmentName
      }
      team {
        id
        teamName
      }
      keywords {
        id
        keyword
        isActive
      }
    }
  }
`

export const GET_KEYWORD_MAPPING_BY_DEPARTMENT_AND_TEAM = gql`
  query GetKeywordMappingsByDepartmentAndTeam(
    $departmentId: ID!
    $teamId: ID!
  ) {
    getKeywordMappingsByDepartmentAndTeam(
      departmentId: $departmentId
      teamId: $teamId
    ) {
      id
      keyword
      suggestsPriority {
        id
        priorityLevel
        slaTime
      }
      isActive
    }
  }
`

export const GET_AVAILABILITY_LOGS = gql`
  query TeamMemberAvailabilityLogs($teamMemberId: Int) {
    teamMemberAvailabilityLogs(teamMemberId: $teamMemberId) {
      id
      previousAvailability
      newAvailability
      reason
      createdAt
      changedBy {
        id
        firstName
        lastName
      }
    }
  }
`
export const GET_PRIORITY_SLA_CONFIGS = gql`
  query GetPrioritySlaConfigs {
    getPrioritySlaConfigs {
      id
      priorityLevel
      slaTime
    }
  }
`

export const GET_TICKET_USERS = gql`
  query getTicketUsers {
    getTicketUsers {
      id
      firstName
      lastName
      email
    }
  }
`
